export default "__VITE_ASSET__98e1174c__"